import { Spr } from "../world/spr.ts";
import { hex, type Col } from "./pal.ts";

/** Catch tins: a glossy can with a coloured band and a pop lid. */
export type TinKind = "capsule" | "gloss" | "myth";

const BAND: Record<TinKind, readonly Col[]> = {
  capsule: [hex("#ffb0b8"), hex("#ff5a6a"), hex("#c23048"), hex("#7a1f3a")],
  gloss: [hex("#b8e4ff"), hex("#4f9cff"), hex("#2a5fc2"), hex("#1c3470")],
  myth: [hex("#fff4b0"), hex("#ffc83e"), hex("#d98a26"), hex("#8e5022")],
};
const STEEL: readonly Col[] = [hex("#ffffff"), hex("#e3e8f4"), hex("#b3bdd6"), hex("#7c86a8"), hex("#4a5070")];

const cache = new Map<string, ImageData>();

export function tinSprite(kind: TinKind, open = false): ImageData {
  const key = `${kind}:${open}`;
  const hit = cache.get(key);
  if (hit) return hit;
  const s = new Spr(18, 22);
  const band = BAND[kind];
  // Body (cylinder shading).
  for (let y = 7; y < 20; y++) {
    for (let x = 3; x < 15; x++) {
      const nx = (x - 8.5) / 6;
      const lam = -nx * 0.95 + 0.15;
      const inBand = y >= 11 && y <= 15;
      s.p(x, y, Spr.tone(inBand ? band : STEEL, lam, x, y, inBand ? 0.2 : 0.4));
    }
  }
  s.oval(9, 19.5, 6, 1.5, STEEL[3]!);
  // Glint.
  s.vline(5, 8, 10, STEEL[0]!);
  if (kind === "myth") { s.p(9, 13, hex("#ffffff")); s.p(8, 13, band[0]!); s.p(10, 13, band[0]!); }
  else s.fill(8, 12, 2, 3, band[0]!);
  // Lid.
  const ly = open ? 1 : 5;
  s.oval(9, ly + 2, 7, 2.2, STEEL[2]!);
  s.oval(9, ly + 1.5, 6, 1.6, STEEL[1]!);
  s.hline(6, ly + 1, 5, STEEL[0]!);
  if (open) {
    s.oval(9, 7, 5.5, 1.3, hex("#1c1530"));
    s.oval(9, 7, 4, 0.8, band[1]!);
  }
  s.outline(hex("#1a1430"), 0.35);
  cache.set(key, s.img);
  return s.img;
}
